import { Reveal } from "@/lib/motion";

const ROWS = [
    {
        label: "Experience",
        body: "3–4 years across commercials, short films, music videos and brand content — as DOP and filmmaker.",
    },
    {
        label: "Assisted",
        body: "Siddhant Khemka, Anant Jain, Vrushabh Sansgiri, Leslie D'Souza & other senior cinematographers — camera departments, lighting workflows, set discipline.",
    },
    {
        label: "On set with",
        body: "Commercial work featuring Emraan Hashmi, Farah Khan, Manoj Bajpayee, Alia Bhatt, Sharvari & others, as assistant cinematographer.",
    },
    {
        label: "Brands",
        body: "Nestlé · TRESemmé · Bru Coffee · Netflix · Traya · ICICI Prudential · Adani Defence · Cipla · MX Fatafat · Veeba Sauces · BGMI & more",
    },
];

const BTS =
    "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?q=85&w=2000&auto=format&fit=crop";

export default function Credibility() {
    return (
        <section data-testid="credibility" className="px-5 md:px-10 py-24 md:py-32 border-t border-line">
            <Reveal>
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-inkdim">Credibility</p>
                        <h2 className="mt-6 font-display font-extrabold uppercase tracking-[-0.02em] leading-[0.95] text-4xl md:text-6xl">
                            Early in the credits.
                            <br />
                            Already on sets that{" "}
                            <em className="font-serif italic font-medium normal-case">matter.</em>
                        </h2>
                    </div>
                    <p className="text-sm text-inkdim max-w-xs leading-relaxed">
                        Independent projects, assisting work and brand sets — the craft learned on both sides of the
                        camera department.
                    </p>
                </div>
            </Reveal>

            <div className="mt-14">
                {ROWS.map((r, i) => (
                    <Reveal key={r.label} delay={i * 0.05}>
                        <div
                            data-testid={`credibility-row-${i}`}
                            className="group grid grid-cols-12 gap-2 md:gap-4 items-baseline border-t border-line py-7 hover:bg-surface transition-colors duration-300 px-2 md:px-4"
                        >
                            <span className="col-span-12 md:col-span-3 text-[10px] font-bold uppercase tracking-[0.22em] text-inkdim">
                                {r.label}
                            </span>
                            <p className="col-span-12 md:col-span-9 font-display font-bold uppercase tracking-tight text-lg md:text-2xl leading-snug">
                                {r.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal>
                <div className="relative overflow-hidden aspect-[21/9] mt-16">
                    <img
                        src={BTS}
                        alt="Film set with lighting and camera crew"
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute bottom-4 left-4 bg-paper px-4 py-2 text-[10px] font-bold uppercase tracking-[0.2em]">
                        On set — where the image is made
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
